import { Users } from '@just-in-types';

export const roles: Users.Role[] = ['admin', 'owner', 'staff', 'user'];

export const userHasAccount = (
  user: Users.User | Users.UserWithAccount,
): user is Users.UserWithAccount => {
  return (user as Users.UserWithAccount).accountData !== null;
};



// WEBPACK FOOTER //
// ./src/globals.ts